import Toast from '../Toast/Toast';
import { add as AddLineItems } from '../../utils/cartUtil';
Toast.init();
class AddToCartButton extends HTMLElement {
    constructor() {
        super();
        this.isAdding = false;
        this.disabled = false;
        this.resetForm = () => {
            // Reset the form after item is added or after error
            this.isAdding = false;
            this.disabled = false;
            this.removeAttribute('disabled');
            this.classList.remove('product-add--adding');
            this.classList.remove('product-add--added');
        };
        this.getProductVariantId = (button) => {
            var _a;
            if (button.dataset.productVariantId !== undefined && button.dataset.productVariantId !== null) {
                return parseInt(button.dataset.productVariantId, 10);
            }
            // idElement is used when products don't contain any variants.
            const idElement = (_a = button.closest('[data-product-form]')) === null || _a === void 0 ? void 0 : _a.querySelector('[name="id"]');
            if (idElement) {
                return parseInt(idElement.value, 10);
            }
            return null;
        };
        this.onSubmit = (event) => {
            event.preventDefault();
            const button = event.currentTarget;
            button.setAttribute('disabled', 'disabled');
            const toastLabel = button.dataset.addedToCartToast;
            const bundleProducts = button.dataset.bundle;
            const productVariantId = this.getProductVariantId(button);
            button.setAttribute('disabled', 'disabled');
            button.classList.remove('product-add--added');
            button.classList.add('product-add--adding');
            if (!this.isAdding) {
                this.isAdding = true;
                button.blur();
                const products = [];
                // Send product to cart
                products.push({
                    id: productVariantId,
                    quantity: 1,
                });
                this.sendProducts(products, toastLabel, button, bundleProducts);
            }
        };
        this.classList.add('product-add--ready');
        this.addEventListener('click', (event) => {
            if (!this.disabled) {
                this.setAttribute('disabled', 'disabled');
                this.classList.remove('product-add--added');
                this.classList.add('product-add--adding');
                this.onSubmit(event);
            }
        });
    }
    // eslint-disable-next-line
    sendProducts(itemsToAdd, toastLabel, button, bundleProducts) {
        // Add the product to the cart
        let allItemsToAdd = [];
        if (bundleProducts) {
            const bundleIds = bundleProducts.split(',');
            for (const bundleId of bundleIds) {
                allItemsToAdd.push({
                    id: bundleId,
                    quantity: 1,
                });
            }
        }
        else {
            allItemsToAdd = itemsToAdd;
        }
        if (this.dataset.additionalProduct && this.dataset.addAdditional === 'true') {
            allItemsToAdd.push({
                id: parseInt(this.dataset.additionalProduct),
                quantity: 1,
            });
        }
        AddLineItems(allItemsToAdd)
            .then((items) => {
            if (Array.isArray(items)) {
                // When added, show an added to cart message in the button
                this.classList.add('product-add--added');
                // When added, show a toast message below the header
                const titles = items.map((item) => `${item.product_title}, ${item.variant_title ? item.variant_title : ''}`).join(', ');
                Toast.show(`<b>${titles}</b> <span>${toastLabel}</span>`);
                // After 2 seconds show the default text in the button, reset quantity to 1 and enable input field and plus button
                setTimeout(() => {
                    this.resetForm();
                }, 2000);
            }
            else {
                Toast.show(items === null || items === void 0 ? void 0 : items.description, 'error');
                this.resetForm();
            }
        })
            .catch(() => {
            Toast.show(dataJs.product.addToCartFailed, 'error');
            this.resetForm();
        });
    }
}
customElements.define('add-to-cart-button', AddToCartButton);
export default AddToCartButton;
